// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V_0htqJ7Ql {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.V_0htqJ7Ql h4 {
  line-height: 3em;
}
.V_0htqJ7Ql .sJasnnJnQd {
  float: left;
  width: 100%;
}
.V_0htqJ7Ql .ooapBMRWhR {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.V_0htqJ7Ql .ooapBMRWhR:hover {
  cursor: pointer;
}
.V_0htqJ7Ql .ooapBMRWhR:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.DP9bJlNVYn .L5ruSS1Vb5:focus {
  outline: none;
}
.DP9bJlNVYn .L5ruSS1Vb5.Rz9tp5aX8a.LEaJQI8e2r {
  background: #375A88;
}
.DP9bJlNVYn .L5ruSS1Vb5.Rz9tp5aX8a.LEaJQI8e2r span {
  color: #fff;
}
.DP9bJlNVYn .LEaJQI8e2r {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.DP9bJlNVYn .LEaJQI8e2r:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.DP9bJlNVYn input {
  height: 38px;
  min-width: 220px;
}
.ooapBMRWhR.WUqtBi4Go7 {
  background: #410102;
}
.ooapBMRWhR._XaWz1unKt {
  background: #911318;
}
.ooapBMRWhR.sBl9G_eKyK {
  background: #D8293B;
}
.ooapBMRWhR._6hqDgdKpvx {
  background: #F2373C;
}
.ooapBMRWhR.CFz6v41crS {
  background: #FC4448;
}
.ooapBMRWhR.b6Rrc7lgJt {
  background: #ED535E;
}
.ooapBMRWhR.atljtHCtFa {
  background: #E34926;
}
.ooapBMRWhR.wJISpRwuj0 {
  background: #FC562B;
}
.ooapBMRWhR.RYwzJ3iE9D {
  background: #FC6722;
}
.ooapBMRWhR.uz5PXGRxyu {
  background: #FD7F24;
}
.ooapBMRWhR.GZcfhZv8h7 {
  background: #FD8D26;
}
.ooapBMRWhR.NArPMHdE2D {
  background: #EC9C3E;
}
.ooapBMRWhR.Sg0s5HZjkK {
  background: #0e673a;
}
.ooapBMRWhR.CRs3mp8rI1 {
  background: #208740;
}
.ooapBMRWhR.L_vjc7b5ZH {
  background: #239718;
}
.ooapBMRWhR.tKrGWkq_iV {
  background: #55A84D;
}
.ooapBMRWhR.k3VUwuxhiJ {
  background: #4BBE5A;
}
.ooapBMRWhR.euJ9J72_Jy {
  background: #0CCA6A;
}
.ooapBMRWhR.X3DZ5ZPIFu {
  background: #0A3C64;
}
.ooapBMRWhR.rW4L8Ta1mE {
  background: #0d487a;
}
.ooapBMRWhR.LJQpC2xpYy {
  background: #10538d;
}
.ooapBMRWhR.pG4X2ItlNO {
  background: #115A99;
}
.ooapBMRWhR.vZK6PpqVLQ {
  background: #3387E2;
}
.ooapBMRWhR.HPCtAHJfTV {
  background: #1BA9CF;
}
.ooapBMRWhR.v1JMoqBp6Q {
  background: #d27c02;
}
.ooapBMRWhR.NapB6tZkJz {
  background: #fb9402;
}
.ooapBMRWhR.VemERsAXzd {
  background: #FD9B30;
}
.ooapBMRWhR.YP8Ft0zbSF {
  background: #FDBE2D;
}
.ooapBMRWhR.vNqDSJVi81 {
  background: #FED831;
}
.ooapBMRWhR.vGXv2BsIzm {
  background: #FFFD38;
}
.ooapBMRWhR.ixypgK1S6c {
  background: #2D215C;
}
.ooapBMRWhR.Z6j24O0Hov {
  background: #483C83;
}
.ooapBMRWhR.VWJ1gd1Q_3 {
  background: #58518d;
}
.ooapBMRWhR.Ik45aUWOac {
  background: #7068A9;
}
.ooapBMRWhR.qmKfYwDIdR {
  background: #7f78b2;
}
.ooapBMRWhR.Rsettrz6Zr {
  background: #8f88bc;
}
.ooapBMRWhR.VDJlZXIXXn {
  background: #000;
}
.ooapBMRWhR.FrEbcLR17r {
  background: #282626;
}
.ooapBMRWhR.Nw9jrDudSb {
  background: #242222;
}
.ooapBMRWhR.glLUSz21Nm {
  background: #353838;
}
.ooapBMRWhR.bCgDU0YKxV {
  background: #666;
}
.ooapBMRWhR.mPDZT9zt2t {
  background: #999;
}
.hwEnxkYIU6 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.hwEnxkYIU6 .bkb7dPK6vN {
  display: none;
}
.qaHgo90wIF {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.qaHgo90wIF .v1IMta7V3a {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0px 12px;
}
.qaHgo90wIF .v1IMta7V3a .Y4jF6Okchg {
  width: 196px;
  height: 32px;
  border-radius: 20px;
  border: 1px solid #e4e9f0;
}
.qaHgo90wIF .v1IMta7V3a .SFh8A4I_9n {
  padding: 0;
  border: 0;
}
.qaHgo90wIF .v1IMta7V3a .APj92w3rwn {
  margin: 0 12px;
}
.qaHgo90wIF .THPW_vk5tG {
  background: #fff;
  border-radius: 4px;
}
.qaHgo90wIF .rCxIf_02vb {
  color: #18181A;
}
.qaHgo90wIF .kmwGNJNTgS::placeholder {
  color: #959499 !important;
}
.qaHgo90wIF .O23jqX8bXC {
  color: #313033;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `V_0htqJ7Ql`,
	"color-row": `sJasnnJnQd`,
	"color-tile": `ooapBMRWhR`,
	"picker-component": `DP9bJlNVYn`,
	"picker-element": `L5ruSS1Vb5`,
	"active": `Rz9tp5aX8a`,
	"btn": `LEaJQI8e2r`,
	"red-1": `WUqtBi4Go7`,
	"red-2": `_XaWz1unKt`,
	"red-3": `sBl9G_eKyK`,
	"red-4": `_6hqDgdKpvx`,
	"red-5": `CFz6v41crS`,
	"red-6": `b6Rrc7lgJt`,
	"orange-1": `atljtHCtFa`,
	"orange-2": `wJISpRwuj0`,
	"orange-3": `RYwzJ3iE9D`,
	"orange-4": `uz5PXGRxyu`,
	"orange-5": `GZcfhZv8h7`,
	"orange-6": `NArPMHdE2D`,
	"green-1": `Sg0s5HZjkK`,
	"green-2": `CRs3mp8rI1`,
	"green-3": `L_vjc7b5ZH`,
	"green-4": `tKrGWkq_iV`,
	"green-5": `k3VUwuxhiJ`,
	"green-6": `euJ9J72_Jy`,
	"blue-1": `X3DZ5ZPIFu`,
	"blue-2": `rW4L8Ta1mE`,
	"blue-3": `LJQpC2xpYy`,
	"blue-4": `pG4X2ItlNO`,
	"blue-5": `vZK6PpqVLQ`,
	"blue-6": `HPCtAHJfTV`,
	"yellow-1": `v1JMoqBp6Q`,
	"yellow-2": `NapB6tZkJz`,
	"yellow-3": `VemERsAXzd`,
	"yellow-4": `YP8Ft0zbSF`,
	"yellow-5": `vNqDSJVi81`,
	"yellow-6": `vGXv2BsIzm`,
	"purple-1": `ixypgK1S6c`,
	"purple-2": `Z6j24O0Hov`,
	"purple-3": `VWJ1gd1Q_3`,
	"purple-4": `Ik45aUWOac`,
	"purple-5": `qmKfYwDIdR`,
	"purple-6": `Rsettrz6Zr`,
	"black-1": `VDJlZXIXXn`,
	"black-2": `FrEbcLR17r`,
	"black-3": `Nw9jrDudSb`,
	"black-4": `glLUSz21Nm`,
	"black-5": `bCgDU0YKxV`,
	"black-6": `mPDZT9zt2t`,
	"picker-theme": `hwEnxkYIU6`,
	"arrow-regular": `bkb7dPK6vN`,
	"leftNavReview": `qaHgo90wIF`,
	"leftNavSearch": `v1IMta7V3a`,
	"leftNavSearchRoot": `Y4jF6Okchg`,
	"leftNavSearchInput": `SFh8A4I_9n`,
	"searchIcon": `APj92w3rwn`,
	"leftNavFilter": `THPW_vk5tG`,
	"selectedItem": `rCxIf_02vb`,
	"previewQuickSearch": `kmwGNJNTgS`,
	"presetOption": `O23jqX8bXC`
};
export default ___CSS_LOADER_EXPORT___;
